<template>
  <section id="overview" class="event-hero">
    <v-container>
      <v-btn outlined class="back-link" :to="{ name: 'reckon-way' }">
        <v-icon left>mdi-arrow-left</v-icon>
        The Reckon Way
      </v-btn>
      <div class="hero-frame">
        <v-img
          v-if="event.heroImage"
          :src="event.heroImage.src | mediaSrc"
          :alt="event.heroImage.alt"
          :aspect-ratio="1.75"
          :position="event.heroImage.position || 'center center'"
          class="hero-image"
        >
          <div class="hero-shade"></div>
          <div class="hero-copy">
            <p>{{ eyebrow }}</p>
            <h1>{{ event.title }}</h1>
            <span v-if="event.subtitle">{{ event.subtitle }}</span>
            <div v-if="heroDetails.length" class="hero-details" aria-label="Event details">
              <span v-for="detail in heroDetails" :key="detail">{{ detail }}</span>
            </div>
            <div v-if="event.heroTags && event.heroTags.length" class="hero-tags" aria-label="Event tags">
              <span v-for="tag in event.heroTags" :key="tag">{{ tag }}</span>
            </div>
          </div>
        </v-img>
        <div v-else class="hero-copy hero-copy-standalone">
          <p>{{ eyebrow }}</p>
          <h1>{{ event.title }}</h1>
          <span v-if="event.subtitle">{{ event.subtitle }}</span>
          <div v-if="heroDetails.length" class="hero-details" aria-label="Event details">
            <span v-for="detail in heroDetails" :key="detail">{{ detail }}</span>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'EventHero',
  props: {
    event: { type: Object, required: true },
  },
  computed: {
    eyebrow() {
      return this.event.classification || this.event.eventType.replace(/-/g, ' ');
    },
    heroDetails() {
      return [this.event.destination, this.event.yearsLabel].filter(Boolean);
    },
  },
};
</script>

<style scoped>
.event-hero { background: #050505; padding: 28px 0 0; }
.back-link { border-color: #454545 !important; color: #fff !important; margin-bottom: 22px; }
.hero-frame { border: 1px solid #2b2b2b; border-radius: 14px; overflow: hidden; }
.hero-image { background: #090909; }
.hero-shade { background: linear-gradient(90deg, rgba(0, 0, 0, 0.92), rgba(0, 0, 0, 0.28) 70%); height: 100%; position: absolute; width: 100%; }
.hero-copy { bottom: 0; left: 0; max-width: 760px; padding: clamp(28px, 6vw, 72px); position: absolute; z-index: 1; }
.hero-copy-standalone { background: linear-gradient(135deg, #151515, #080808); position: relative; }
.hero-copy p { color: #f0b13c; font-family: "Oswald", sans-serif; font-weight: 800; letter-spacing: 0.14em; margin: 0 0 10px; text-transform: uppercase; }
.hero-copy h1 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2.4rem, 7vw, 5rem); line-height: 0.96; margin: 0; }
.hero-copy span { color: #f1f1f1; display: block; font-size: clamp(1rem, 2.4vw, 1.35rem); line-height: 1.45; margin-top: 18px; }
.hero-details { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 22px; }
.hero-details span { background: rgba(0, 0, 0, 0.62); border: 1px solid rgba(255, 255, 255, 0.28); border-radius: 999px; color: #fff; font-size: 0.78rem; font-weight: 800; margin: 0; padding: 7px 12px; text-transform: uppercase; }
.hero-tags { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 14px; }
.hero-tags span { background: rgba(240, 177, 60, 0.12); border: 1px solid rgba(240, 177, 60, 0.4); border-radius: 999px; color: #f5c76d; font-size: 0.7rem; font-weight: 700; margin: 0; padding: 5px 9px; }
@media (max-width: 600px) {
  .hero-image { min-height: 420px; }
  .hero-shade { background: linear-gradient(0deg, rgba(0, 0, 0, 0.96), rgba(0, 0, 0, 0.14)); }
  .hero-copy { padding: 26px; }
  .hero-tags { display: none; }
}
</style>
